/**
 * @module Rating
 */
import {getField, updateField} from 'vuex-map-fields';
import {mixin} from "../../helpers/helper";

export default {
    mixins: [mixin],
    namespaced: true,
    state: {
        comment: '',
        star: 0,
        section: '',
        myErrors: [],

    },
    getters: {
        getField
    },
    mutations: {
        updateField,

    },
    actions: {

        saveRating: function(state)
        {
            axios.post('/api/v1/rating/saveRating', {
                star: state.state.star,
                comment: state.state.comment,
                section: state.state.section,
                version: 1,
            })

        }

    }
}